import requests from './httpService';

const SubscriptionService = {
  getUpgradeQuote(academicYearId) {
    return requests.get(`/subscription/upgrade/quote?academicYearId=${encodeURIComponent(String(academicYearId || ''))}`);
  },

  initiateUpgradePayment(body) {
    return requests.post('/subscription/upgrade/initiate', body);
  },

  getReceipt(orderId) {
    return requests.get(`/subscription/receipt/${encodeURIComponent(orderId)}`);
  },

  getInvoice(orderId) {
    return requests.get(`/subscription/invoice/${encodeURIComponent(orderId)}`);
  },

  listSuccessfulInvoices(limit = 50) {
    return requests.get(`/subscription/invoices?limit=${encodeURIComponent(String(limit))}`);
  },
};

export default SubscriptionService;

